// extracted by mini-css-extract-plugin
module.exports = {"empty-data":"index_empty-data_J1DvD"};